import { proxy } from "valtio";
import { UserDataObj } from "../types/types";

export const userDataStore = proxy<{
  userData: UserDataObj | undefined;
}>({
  userData: undefined,
});
